import { all, fork } from "redux-saga/effects";
import { watchCommonSaga } from "./common";
import { watchUserMenuSaga } from "../../containers/Sidebar/state/saga";
import { watchProductsGroupSaga } from "../../containers/ProductGroup/state/saga";
import { watchProductsSaga } from "../../containers/Products/state/saga";
import { watchCombosSaga } from "../../containers/Combos/state/saga";
import { watchKeyPosSaga } from "../../containers/KeyPos/state/saga";
import { watchFileApprovalSaga } from "../../containers/FileApprovals/state/saga";
import { watchPosDecentralizedSaga } from "../../containers/PosDecentralized/state/saga";
import { watchSurveyPosSaga } from "../../containers/Survey/state/saga";
import { watchGeotreesSaga } from "../../containers/GeoTree/state/saga";
import { watchEzdInfoSaga } from "../../containers/Ezd/state/saga";
import { watchSelloutFileApprovalSaga } from "../../containers/Sellout/FileApprovals/state/saga";
import { watchValidationRulesSaga } from "../../containers/ValidationRules/state/saga";
import { watchSelloutFileUploadSaga } from "../../containers/Sellout/FileSubmission/state/saga";


export default function* rootSaga() {
  yield all([
    fork(watchCommonSaga),
    fork(watchUserMenuSaga),
    fork(watchProductsGroupSaga),
    fork(watchProductsSaga),
    fork(watchCombosSaga),
    fork(watchKeyPosSaga),
    fork(watchFileApprovalSaga),
    fork(watchPosDecentralizedSaga),
    fork(watchSurveyPosSaga),
    fork(watchGeotreesSaga),
    fork(watchEzdInfoSaga),
    fork(watchSelloutFileApprovalSaga),
    fork(watchValidationRulesSaga),
    fork(watchSelloutFileUploadSaga),
  ]);
}
